import React from 'react';
import '../App.css'; 

const BannerSection = () => {
  return (
    <div 
      className="container-fluid" 
      id="bannerSection" 
      style={{ margin: 0, maxWidth: "100%"}} // Inline style to override bottom margin
    >
      <img 
        src="/FTTH_SA-Banner-Image-Free-installation-1.webp" 
        alt="Banner" 
        className="img-fluid w-100" 
      />
    </div>
  );
};

export default BannerSection;

